import { SVGProps } from "react";

const Key = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.7887 14.9301C17.7287 16.9801 14.7787 17.6101 12.1887 16.8001L7.47868 21.5001C7.13868 21.8501 6.46868 22.0601 5.98868 21.9901L3.80868 21.6901C3.08868 21.5901 2.41868 20.9101 2.30868 20.1901L2.00868 18.0101C1.93868 17.5301 2.16868 16.8601 2.49868 16.5201L7.19868 11.8201C6.39868 9.22007 7.01868 6.27007 9.07868 4.22007C12.0287 1.27007 16.8187 1.27007 19.7787 4.22007C22.7387 7.17007 22.7387 11.9801 19.7887 14.9301Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.89062 17.49L9.19062 19.79"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 11C15.3284 11 16 10.3284 16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Key;
